import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const typeOccurrencesStartRequest = () => {
  return {
    type: 'TYPE_OCCURRENCES_START_REQUEST'
  };
};

export const typeOccurrencesEndRequest = () => {
  return {
    type: 'TYPE_OCCURRENCES_END_REQUEST'
  };
};

export const getAllTypeOccurrencesSuccess = ({ data }) => {
  return {
    type: 'TYPE_OCCURRENCES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllTypeOccurrencesError = error => {
  return {
    type: 'TYPE_OCCURRENCES_GET_ALL_ERROR',
    payload: error
  };
};

export const addTypeOccurrencesSuccess = ({ data }) => {
  return {
    type: 'TYPE_OCCURRENCES_ADD_SUCCESS',
    payload: data
  };
};

export const addTypeOccurrencesError = error => {
  return {
    type: 'TYPE_OCCURRENCES_ADD_ERROR',
    payload: error
  };
};

export const editTypeOccurrencesSuccess = ({ data }) => {
  return {
    type: 'TYPE_OCCURRENCES_EDIT_SUCCESS',
    payload: data
  };
};

export const editTypeOccurrencesError = error => {
  return {
    type: 'TYPE_OCCURRENCES_EDIT_ERROR',
    payload: error
  };
};

export const removeTypeOccurrencesSuccess = id => {
  return {
    type: 'TYPE_OCCURRENCES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeTypeOccurrencesError = error => {
  return {
    type: 'TYPE_OCCURRENCES_REMOVE_ERROR',
    payload: error
  };
};

export const typeOccurrencesModifyStore = ({ data }) => {
  return {
    type: 'TYPE_OCCURRENCES_MODIFY_STORE',
    payload: data
  };
};

export const addTypeOccurrences = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(typeOccurrencesStartRequest());
      const response = await api().post('/api/type_occurrences', data);
      dispatch(addTypeOccurrencesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'typeOccurrences',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addTypeOccurrencesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(typeOccurrencesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllTypeOccurrences = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(typeOccurrencesStartRequest());
      const response = await api().get('/api/type_occurrences', { params });
      dispatch(getAllTypeOccurrencesSuccess(response));
    } catch (err) {
      dispatch(getAllTypeOccurrencesError(err));
    } finally {
      dispatch(typeOccurrencesEndRequest());
    }
  };
};

export const editTypeOccurrences = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(typeOccurrencesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(typeOccurrencesStartRequest());
      const id = data._id;
      const response = await api().put('/api/type_occurrences/' + id, data);
      dispatch(editTypeOccurrencesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'typeOccurrences',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/type_occurrences'));
      }
    } catch (err) {
      dispatch(editTypeOccurrencesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeTypeOccurrences = id => {
  return async dispatch => {
    try {
      dispatch(typeOccurrencesStartRequest());
      await api().delete('/api/type_occurrences/' + id);
      dispatch(removeTypeOccurrencesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'typeOccurrences',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Tipo de ocorrência removida com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeTypeOccurrencesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover tipo de ocorrência.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(typeOccurrencesEndRequest());
    }
  };
};

export const restoreTypeOccurrences = data => {
  return async dispatch => {
    try {
      dispatch(typeOccurrencesStartRequest());
      const id = data._id;
      const response = await api().put('/api/type_occurrences/' + id, data);
      dispatch(editTypeOccurrencesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'typeOccurrences',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Tipo de ocorrência restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editTypeOccurrencesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar tipo de ocorrência.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(typeOccurrencesEndRequest());
    }
  };
};
